import { useSyncExternalStore } from 'react';

import type { DetailLayout } from '@flow/ui/components';

/**
 * Where the detail panel goes, by the width of the window (docs/05 §5): a column beside the list
 * on the desktop, a modal over it on a tablet, and the whole screen on a phone.
 */

const QUERIES = {
  column: '(width >= 1024px)',
  overlay: '(width >= 768px)',
} as const;

function currentLayout(): DetailLayout {
  if (typeof window === 'undefined') return 'column';
  if (window.matchMedia(QUERIES.column).matches) return 'column';
  return window.matchMedia(QUERIES.overlay).matches ? 'overlay' : 'fullscreen';
}

export function useDetailLayout(): DetailLayout {
  return useSyncExternalStore(
    (onChange) => {
      const lists = [window.matchMedia(QUERIES.column), window.matchMedia(QUERIES.overlay)];
      for (const list of lists) list.addEventListener('change', onChange);
      return () => {
        for (const list of lists) list.removeEventListener('change', onChange);
      };
    },
    currentLayout,
    () => 'column' as const,
  );
}
